// extracted by mini-css-extract-plugin
export default {"main":"styles_main__6hUvw","image":"styles_image__sW+yM","imageActions":"styles_imageActions__LF7sz","uploadButton":"styles_uploadButton__7aCKf"};